import { LocalizedTypography } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, IconName, Stack, Typography } from '@optimus-web/core';
import { Section } from '../Section';
import { ShiftTransactionsTable } from '../ShiftTransactionsTable';

interface Props {
    cashierId: string;
    shiftId?: string;
    showAddTransaction: boolean;
}

export const TransactionSection = ({ cashierId, shiftId, showAddTransaction }: Props) => {
    const transactionCount = 75;

    return (
        <Section
            title={
                <Stack spacing="100">
                    <LocalizedTypography
                        textKey={TextKey.CashierTransactionPlural}
                        textStyle="titleMediumStrong"
                        as="h2"
                    />
                    <Typography textStyle="titleMedium" variant="tertiary" as="p">
                        {transactionCount}
                    </Typography>
                </Stack>
            }
            actions={
                showAddTransaction ? (
                    <Button icon={IconName.Add} type="button">
                        {lt('CashierShiftAddTransaction')}
                    </Button>
                ) : null
            }
        >
            <ShiftTransactionsTable cashierId={cashierId} shiftId={shiftId} />
        </Section>
    );
};
